import styled from 'styled-components'

import {
  Carat,
  TypeStyle,
  fromMd,
  timingSlow,
  timingSlower,
  untilMd,
  zIndexModal,
} from '@syconium/little-miss-figgy'

import { NextDialog, NextDialogBackdrop } from '../../../app/_components/dialogs/NextDialog.client'

export const Dialog = styled(NextDialog)`
  border-radius: 0;
  min-width: initial;
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
  margin: 0;
  background: ${o => o.theme.color.fill.subtle};
  border-top: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  text-align: left;

  /* Slide up animation (match legacy NextModal) */
  transform: translateY(24px);
  opacity: 0;
  transition:
    transform ${timingSlow} ease,
    opacity ${timingSlow} ease;

  &[data-enter] {
    transform: translateY(0);
    opacity: 1;
  }
`

export const DialogBody = styled.div`
  padding: 0;
  height: 100%;
  ${fromMd} {
    overflow-y: hidden;
  }
`

const BACKDROP_TIMING = timingSlower
const DIALOG_TIMING = timingSlow
const BACKDROP_Z_INDEX = zIndexModal + 1

export { BACKDROP_TIMING, DIALOG_TIMING }

export const Backdrop = styled(NextDialogBackdrop)`
  padding: 0;
  align-items: flex-end;
  justify-content: center;
  z-index: ${BACKDROP_Z_INDEX};
  background-color: transparent;
  ${fromMd} {
    align-items: center;
  }
  overflow: hidden;
`

export const DialogContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  inset: 0px;
  z-index: ${zIndexModal};
  overflow: hidden;
  padding: 0;
`
export const Title = styled.h1`
  ${TypeStyle.css.headlineExtraSmall}
  text-transform: uppercase;
`

export const ImageHeader = styled.div`
  text-align: center;
  padding-bottom: ${o => o.theme.spacing(5)};

  ${untilMd} {
    display: none;
  }
`

export const Section = styled.div`
  ${fromMd} {
    min-height: 100vh;
    display: flex;
  }
  &:first-of-type {
    flex: 1;
    flex-direction: column;
  }

  &:nth-of-type(2) {
    ${untilMd} {
      height: 100%;
      background-color: ${o => o.theme.color.fill.background};
      z-index: 100;
    }
    ${fromMd} {
      flex: 0;
    }
  }
`

export const ImagePreviewWrap = styled.div`
  width: 100%;
`

export const Container = styled.div`
  display: flex;
  ${untilMd} {
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
  }

  ${fromMd} {
    width: 100%;
    height: calc(100% - ${o => o.theme.spacing(16)});
  }
`

export const EmbroideryAccordionOption = styled.div`
  border-bottom: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.subtle};
  padding: ${o => o.theme.spacing(5, 0)};
`

export const AccordionHeaderSummary = styled.div`
  flex-basis: 100%;
`

export const AccordionCarat = styled(Carat)``

export const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 100%;
  cursor: pointer;
  flex-wrap: wrap;

  &[aria-expanded='true'] {
    ${AccordionHeaderSummary} {
      display: none;
    }
    ${AccordionCarat} {
      transform: rotate(-90deg);
    }
  }
`

export const AccordionDetails = styled.div`
  padding-top: ${o => o.theme.spacing(2)};
`

export const AccordionHeading = styled(TypeStyle.HeadlineMicro)`
  text-transform: uppercase;
  letter-spacing: ${o => o.theme.typography.font.letterSpacing.wide};
  font-weight: ${o => o.theme.typography.font.weight[700]};
`

export const AccordionSubHeading = styled(TypeStyle.HeadlineMicro)`
  text-transform: capitalize;
  color: ${o => o.theme.color.text.secondary.on.subtle};
`
